import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b19b04f6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b19b04f6')) {
      api.createRecord('b19b04f6', component.options)
    } else {
      api.reload('b19b04f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b19b04f6&", function () {
      api.rerender('b19b04f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comps/attr-table/index.vue"
export default component.exports